export const DAILY_REWARD_CYCLE_LENGTH = 7;
export const STREAK_MULTIPLIER_INCREMENT = 0.1;
export const STREAK_MULTIPLIER_MAX = 2.0;
/** Hardcoded fallbacks only — live values always come from RemoteConfig. */
export const DAILY_REWARD_DEFAULTS = {
    1: { coins: 100, gems: 0 },
    2: { coins: 120, gems: 0 },
    3: { coins: 150, gems: 1 },
    4: { coins: 150, gems: 0 },
    5: { coins: 200, gems: 2 },
    6: { coins: 200, gems: 0 },
    7: { coins: 300, gems: 3 },
};
export function getDayCoinsKey(day) {
    return `daily_reward_day_${day}_coins`;
}
export function getDayGemsKey(day) {
    return `daily_reward_day_${day}_gems`;
}
